// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:19
import { AddressComplement_abstract } from './../abstract/SagaBase/AddressComplement_abstract';
export class AddressComplement extends AddressComplement_abstract {}
